import { Platform } from 'react-native';
import { DirectRealtimeNative } from './DirectRealtimeNative';
import { DirectRealtimeWeb } from './DirectRealtimeWeb';
import type { VoiceTransport } from './VoiceTransport';

export type { LiveConnState, LiveEvents, VoiceTransport } from './VoiceTransport';

export function createVoiceTransport(): VoiceTransport {
  return Platform.OS === 'web' ? new DirectRealtimeWeb() : new DirectRealtimeNative();
}
